import { render, staticRenderFns } from "./FacetTagMenu.vue?vue&type=template&id=1b89d2b3&"
import script from "./FacetTagMenu.vue?vue&type=script&lang=js&"
export * from "./FacetTagMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports